import { FC } from 'react';

import { SplashLoaderContainer } from './styles';
import { Logo } from '../Logo';
import { Loader } from '../Loader';

export const SplashLoader: FC = () => {
  return (
    <SplashLoaderContainer>
      <Logo />
      <Loader size={100} type="bar" color="primary" />
    </SplashLoaderContainer>
  );
};
